import { Redirect, Route } from "react-router-dom";
import { isAuthenticated } from "../services/auth";
import TopBar from "../shared/header";
import {Container} from '../shared/GlobalStyles/styles'
import { SideBar } from "../components/SideBar";
import { PermissionRoutesPrimaries } from "./permissionRoutesPrimaries";
import RoutesSessionLogin from "./routes-session-login";

const RouteWrapper = ({ component: Component, ...rest }) => {

    return <RoutesSessionLogin>
        <PermissionRoutesPrimaries rest={rest}>
            <Route 
                {...rest}
                render = { props =>

                        isAuthenticated('LOGIN') ? (   
                            <Container>
                                <SideBar/>
                                <TopBar/>
                                <Component 
                                    {...props} 
                                    {...rest}
                                    fiscal={rest.fiscal} 
                                    nfe={rest.nfe}
                                />
                            </Container>    
                        ) :(
                            // redirecionando o usuario
                            <Redirect to={{ pathname: '/', state:{from: props.location } }} />
                    
                        )}
            
                
            />
        </PermissionRoutesPrimaries>

    </RoutesSessionLogin>
}

export default RouteWrapper;